/**
 * Chave de idempotência das escritas do portal.
 *
 * A API exige `Idempotency-Key` (UUID) em toda escrita e guarda a resposta por 24h:
 * a mesma chave devolve a resposta original em vez de criar recurso novo. O carimbo
 * é feito no interceptor do axios (`lib/api/axios.ts`), e não chamada a chamada —
 * assim uma request de escrita nova nasce protegida e nenhuma cai em 400 por
 * esquecimento.
 */
export const IDEMPOTENCY_HEADER = "Idempotency-Key";

/** Métodos que a API trata como escrita (e que, portanto, exigem a chave). */
export const UNSAFE_METHODS = new Set(["post", "put", "patch", "delete"]);

/**
 * UUID v4 novo. `crypto.randomUUID` só existe em contexto seguro (https/localhost);
 * fora dele caímos em `getRandomValues`, que é universal — sem isso o portal
 * servido por http num IP de rede quebraria em toda escrita.
 */
export function newIdempotencyKey(): string {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }

  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  bytes[6] = ((bytes[6] as number) & 0x0f) | 0x40; // versão 4
  bytes[8] = ((bytes[8] as number) & 0x3f) | 0x80; // variante RFC 4122

  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
